import { colors } from '../../constants';
const MuiSpeedDialAction = {
  fab: {
    backgroundColor: colors.oriGrey[500],
    color: colors.commonColors.white
  },
  staticTooltipLabel: {
    backgroundColor: 'transparent',
    boxShadow: 'unset',
    color: colors.commonColors.white,
    fontWeight: 'bold',
    padding: '4px 12px'
  },
  tooltipPlacementLeft: {
    '& $staticTooltipLabel': {
      marginRight: 0
    }
  }
};
export default MuiSpeedDialAction;